/**
 * 线下培训班级学员列表功能
 * @Author:wuTao
 * @Date 2020/3/6
 */
import React from 'react';
import {connect} from 'dva';
import {reduxTemplateConfig, templateConfig} from './config';
import { seatsOut } from '@/utils'
import {component_tool, framework_tool, utils_tool} from '@/tool'
let {checkStrLength,Session} = utils_tool;
let { WizSpin, WizBrowserExport,WizModal} = component_tool;
let {WizContainer, WizReduxTemplate, modelUtils} = framework_tool;
import { WizTableForm , WizModalUserIdentityShow, WizPhoneCall, WizCallLog } from '@/containers/common';
import ResultCharts from './../classResult/resultCharts'
import { WizCard } from 'wiz-components/lib';
const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location && history.location.record) {
      record = history.location.record;
      Session.set('classDetailRecordFromStudent', record)
    } else {
      record = Session.get('classDetailRecordFromStudent') || {}
    }
  } else {
    record = Session.get('classDetailRecordFromStudent') || {}
  }
  return record
}
class ClassStudentList extends WizContainer {

  componentName = 'ClassStudentList';

  constructor(props) {
    super(props);
    const {history} = props;
    this.state = {
      addClassStudentVisible: false,
      personIds:[],
      classStudentRecord:{},
      showUserPersonInfoVisible: false,
      callModalShow: false,
      locCallRecord: {},
      callLogShow: false,
    };
    this.initialValue = getParamRecord(props.history);
  }

  _componentWillMount() {
    const {history} = this.props;
    if (this.initialValue.id) {
      this.getClassStudentPersonIdsList();
    }
  }
  componentDidMount() {
    seatsOut({ fun: this._seatsLoginOut })
  }

  _seatsLoginOutOver(nextProps, nextState) {
    if (nextProps.seatsLoginOut.success && nextProps.seatsLoginOut.data) {
    } else {
      wizNotice.error(nextProps.seatsLoginOut.msg);
    }
    return true;
  }
  _seatsLoginOut = (params) => {
    ClinkAgent.setup({ sipPhone: false, debug: false }, function () {
      // 注册退出响应回调方法
      ClinkAgent.registerCallback(ClinkAgent.ResponseType.LOGOUT, function (result) {
        if (result.code === 0) {
          // 退出成功
          console.log('退出成功777')
        } else {
          // 退出失败
        }
      });
    });
    ClinkAgent.logout({ logoutMode: 1, removeBinding: 0 });
    this.doAction({
      path: 'smartPhone/seatsLoginOut',
      payload: {
        key: "seatsLoginOut",
        apiParams: {
          ...params
        }
      }
    });
  }
  /**获取班级对应的学员personIds数据 */
  getClassStudentPersonIdsList() {
    this.doAction({
      path: 'classStudentManagement/getPersonIdsByClassInfoId',
      payload: {
        key: 'classStudentPersonIds',
        apiParams: {
          id: this.initialValue.id,
        }
      }
    });
  }

  /**获取班级学员列表 */
  getClassStudentList() {
    this.doAction({
      path: 'classStudentManagement/getListByPage',
      payload: {
        key: 'classStudentManagement@getListByPage',
        apiParams: {
          classInfoId: this.initialValue.id,
        }
      }
    });
  }

  propsAndStateOnChange = {
    addClassStudent: this._addClassStudentOver.bind(this),
    classStudentPersonIds: this._getClassStudentPersonIdsOver.bind(this),
    seatsLoginOut: this._seatsLoginOutOver.bind(this),
  };

  _getClassStudentPersonIdsOver(nextProps, nextState) {
    if (nextProps.classStudentPersonIds.code == 1) {
      this.setState({
        personIds: nextProps.classStudentPersonIds.data ? nextProps.classStudentPersonIds.data : []
      });
    }
    return true;
  }


  _addClassStudentOver(nextProps, nextState) {
    if (nextProps.addClassStudent.code == 1) {
      wizNotice.success('保存成功');
      this.getClassStudentPersonIdsList();
      this.getClassStudentList(); //强制刷新 WizReduxTemplate的列表数据
    } else {
      wizNotice.error('提交失败：' + nextProps.addClassStudent.msg);
    }
    return true;
  }

  /**
   * 页面动作操作后进行提示
   * @param nextProps
   * @param nextState
   * @param key
   * @returns {boolean}
   * @private
   */
  _handleClassStudent(nextProps, nextState, key) {
    let o = nextProps[key];
    if (o['success']) {
      wizNotice.success(o['msg']);
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  _handleClassStudentFile(nextProps, nextState, key) {
    let o = nextProps[key];
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '手机号',
        field: 'mobile',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '邮箱',
        field: 'email',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '身份证号/工号',
        field: 'idCard',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      // {
      //   headerName: '用户属性',
      //   field: 'userTypeName',
      //   width: 15,
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: { vertical: 'bottom', horizontal: 'left' },
      //   },
      // },
      // {
      //   headerName: '账号状态',
      //   field: 'stateName',
      //   width: 15,
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: { vertical: 'bottom', horizontal: 'left' },
      //   },
      // },
      {
        headerName: '组织名称',
        field: 'orgName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '组织编码',
        field: 'orgCode',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '岗位',
        field: 'positionName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '区域',
        field: 'areaName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '任职状态',
        field: 'jobStateName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '是否请假',
        field: 'leaveStateStr',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '创建人',
        field: 'creator',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },

      {
        headerName: '创建时间',
        field: 'createTime',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },

      {
        headerName: '学员来源',
        field: 'classStudentSource',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },

      // {
      //   headerName: '成绩',
      //   field: 'score',
      //   width: 10,
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: { vertical: 'bottom', horizontal: 'left' },
      //   },
      // },
      // {
      //   headerName: '通过状态',
      //   field: 'scoreStateName',
      //   width: 15,
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: { vertical: 'bottom', horizontal: 'left' },
      //   },
      // },
      // {
      //   headerName: '评语',
      //   field: 'comment',
      //   width: 30,
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: { vertical: 'bottom', horizontal: 'left' },
      //   },
      // }

      {
        headerName: '报名人',
        field: 'coordinatorFullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '报名人账号',
        field: 'coordinatorUserName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '报名人手机号',
        field: 'coordinatorMobile',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '报名人邮箱',
        field: 'coordinatorEmail',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ];
    if (o['success']) {
      let data = o['data'];
      if(data && data instanceof Array ){
        data.forEach(element=>{
          if(element.scoreState==0 || element.scoreState==3){
            element.score = '';
          }
          if(element.leaveState===0 ){
            element.leaveStateStr = '否';
          }else{
            element.leaveStateStr = '是';
          }
          switch (element.classStudentSource){
            case 0 :
              element.classStudentSource = "班级添加"
              break;
            case 1 :
              element.classStudentSource = "报名添加"
              break;
            case 2 :
              element.classStudentSource = "扫码添加"
              break;
            default:
                element.classStudentSource = ""
          }

        })
      }
      WizBrowserExport({
        title: '班级人员详细信息',
        sheetName: '班级人员详细信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '班级人员详细信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  //选择人员弹出框确定按钮事件
  _addClassStudentSubmit = (obj, e) => {
    let initialValue = this.initialValue;
    const {id} = initialValue;
    let classStudentLists = [];
    let personIdList = [];
    let isRepeat = false;
    if (obj && obj['valueRows'] && obj['valueRows'] instanceof Array && obj['valueRows'].length > 0) {
      obj['valueRows'].forEach(key => {
          let student={};
          const {personId,orgId,positionId, fullName, userName} = key;
          if (personIdList[personId]){
            wizNotice.warn('学员账号【'+userName+'】,姓名【'+fullName+'】重复，请确认！');
            isRepeat = true;
            return;
          }
        personIdList[personId] = personId;
        student={
          classInfoId: id,
          personId,
          orgId,
          positionId
        };
        classStudentLists.push(student);
      });
      if (classStudentLists.length && !isRepeat){
        this.doAction({
          path: 'classStudentManagement/add',
          payload: {
            key: 'addClassStudent',
            apiParams: {
              classStudents:classStudentLists
            }
          }
        });
      }
    }
    if (!isRepeat){
      this.setState({
        addClassStudentVisible: false,
      });
    }
  };

  _onCancel= (e) =>{
    this.setState({
      addClassStudentVisible: false,
    });
  };
  /**
    * 拨打电话
  */
  openCall = (record) => {
    this.setState({ callModalShow: true, locCallRecord: record })
  }
  //通话记录
  openCallLog = (record) => {
    this.setState({ callLogShow: true, locCallRecord: record?record:{} })
  }
  _render() {
    //初始化班级ID
    const {classStudentManagementLoading} = this.props;
    let initialValue = this.initialValue;
    const {addClassStudentVisible, personIds,showUserPersonInfoVisible,classStudentRecord, callModalShow, locCallRecord, callLogShow} = this.state;
    const {id, name, status,scoreState} = initialValue;
    let _templateConfig = templateConfig({
      classInfoId: id, className: name,personIds:personIds,scoreState,status,classDetail:initialValue,_this:this,
      _btnFun: (e) => {
        if (status && status===1){
          this.setState({
            addClassStudentVisible: true,
          });
        }else {
          wizNotice.warn('请选择已发布的班级进行添加学员！');
        }
      },
      _btnLookUserFun:(e)=> {
        if (e.record){
          this.setState({
            classStudentRecord:e.record,
            showUserPersonInfoVisible: true,
          })
        }
      }
    });
    //let userIdentityConfig = WizTableForm.Config.userIdentity(this, { apiParams: { jobState: 1, disabled: 0, ninPersonIdList: personIds && personIds.length>0 ? personIds : null } });
    let _reduxTemplateConfig = reduxTemplateConfig({
      classInfoId: id,
      templateConfig: _templateConfig,
      apiDataFormat: {
        add: this._handleClassStudent,
        delete: this._handleClassStudent,
        exportQuestionnaire: this._handleClassStudent,
        exportPerson: this._handleClassStudentFile,
        look: this._handleClassStudent,
      },
      addClassStudentVisible:this.state.addClassStudentVisible
    });
    // let tableFormProps = {
    //   title: '选择学员',
    //   showModal:true,
    //   showSelectValue: false,
    //   visible: addClassStudentVisible,
    //   selectType: 'checkbox',
    //   initRows: [],
    //   value: [],
    //   onSubmit:this._addClassStudentSubmit,
    //   onCancel: this._onCancel,
    // };
    let lookUserPersonInfoModal = {
      title: '查看已选任职',
      visible:showUserPersonInfoVisible,
      personId: classStudentRecord.personId ? classStudentRecord.personId : null,
      orgId:classStudentRecord.orgId ? classStudentRecord.orgId : null,
      positionId:classStudentRecord.positionId ? classStudentRecord.positionId : null,
      onCancel:(e) =>{
        this.setState({
          showUserPersonInfoVisible: false,
          classStudentRecord:{},
        });
      },
    };
    return <>
        <ResultCharts classInfoId={id} />
        <WizCard title={'班级学员'}>
          <WizReduxTemplate {..._reduxTemplateConfig} />
          <WizModalUserIdentityShow {...lookUserPersonInfoModal}/>
          {callModalShow ? <WizPhoneCall entityType={5} modalShow={callModalShow} record={locCallRecord}
            parentEntityId={id} closeModal={() => this.setState({ callModalShow: false })} /> : null}
          <WizModal title='通话记录' destroyOnClose={true} visible={callLogShow} footer={null} onCancel={() => this.setState({ callLogShow: false })} width={850}>
            <WizCallLog entityType={5} entityId={locCallRecord.id} parentEntityId={id}/>
          </WizModal>
        </WizCard>
        {/* <WizTableForm key={new Date().getTime()} {...userIdentityConfig} {...tableFormProps}/> */}

      </>
  }
}

const mapStateToProps = (state, ownProps) => {
  const {classStudentManagement,smartPhone } = state;
  const addClassStudent = modelUtils.getModelEntity(classStudentManagement, "addClassStudent");
  const classStudentPersonIds = modelUtils.getModelEntity(classStudentManagement, "classStudentPersonIds");
  const seatsLoginOut = modelUtils.getModelEntity(smartPhone, 'seatsLoginOut');
  const load = modelUtils.getLoadingState(state, ['classStudentManagement']);
  return {
    addClassStudent,
    classStudentPersonIds,
    seatsLoginOut,
    ...load
  }
};

export default connect(mapStateToProps)(ClassStudentList);
